import { Box, Button, Grid, Link, Stack, Typography } from "@mui/material";
import React from "react";
import AuthButton from "./AuthButton";
import { MenuOption, SelectInput } from "./selectOptions";
import { SportsResponse, SitesResponse } from "./store/types";
import { StyledSettingsContainer } from "./_components";
import { useHistory, useParams } from "react-router-dom";
import { siteLogos, sportLogos } from "../utils/logos";
import { setSport, setSite, setSlate } from "./store/actions";
import { connect, useDispatch, useSelector } from "react-redux";
import { getIsMobileApp } from "../../utils/mobileApp";
import { IRootState } from "../../store/reducer";
import { APIConstants } from "../utils/api/constants";
import { getSupportedSports, SupportedSites } from "./helpers/SelectorHelpers";

interface OwnProps {
  readonly title: string;
  readonly app: string;
  readonly backgroundColor: string;
}

interface ReduxProps {
  readonly selectedSport: SportsResponse;
  readonly selectedSite: SitesResponse;
}

interface DispatchProps {
  readonly SetSport: (sport: SportsResponse) => void;
  readonly SetSite: (site: SitesResponse) => void;
}

type Props = OwnProps & ReduxProps & DispatchProps;


const NotAuthenticatedView = (props: Props) => {
  const { selectedSport, selectedSite, app, backgroundColor, SetSport, SetSite } = props;
  const sports = getSupportedSports(app);
  const dispatch = useDispatch();
  const [auth, setAuth] = React.useState(false);
  const {authenticated} = useSelector((state: IRootState) => state.common);
  const isMobileApp = getIsMobileApp();
  const history = useHistory();
  const routeParams = useParams<{ league: string }>();
  
  const handleSportSelect = (contest: SportsResponse) => {
    SetSport(contest);
    history.push(`${contest.sport}`);
    dispatch(setSlate({} as any));
  }

  const handleSiteSelect = (site: SitesResponse) => {
    SetSite(site);
    dispatch(setSlate({} as any));
  }

  React.useEffect(() => {
    setAuth(authenticated.status === APIConstants.SUCCEEDED && authenticated.data.userId);
  }, [authenticated]);

  return (
    <StyledSettingsContainer>
      <Grid container>
        <Grid container direction='row' justifyContent='space-between' style={{ padding: '16px 20px', backgroundColor: backgroundColor }}>
          <Grid item xs={isMobileApp ? 12 : 2} container spacing={1} alignItems="center">
            <Stack direction="row" spacing={1}>
              <SelectInput
                data={sports?.map(x => ({ name: x.sport, logo: sportLogos[x.sport?.toUpperCase()]?.logo, value: x.sport, option: x, } as MenuOption<SportsResponse>)) ?? []}
                label="League"
                value={selectedSport?.sport || ((routeParams.league?.toUpperCase() as string) || 'NFL')}
                onSelect={(selection: any) => handleSportSelect(selection as SportsResponse)}
              />
              <SelectInput
                data={SupportedSites?.map(x => ({ name: siteLogos[x.site?.toLowerCase()]?.name || x.site, logo: siteLogos[x.site?.toLowerCase()]?.logo || '' , value: x.site, option: x, } as MenuOption<SitesResponse>))}
                label="Site"
                value={selectedSite?.site || 'DK'}
                onSelect={(selection: any) => handleSiteSelect(selection as SitesResponse)}
              />
              </Stack>
          </Grid>
          {!isMobileApp && (
            <>
              <Grid container item xs={8} lg={5} alignItems="center">
                <Typography variant='h6' gutterBottom align='left' sx={{ fontSize: {xs: '12px', lg: '12pt'}, lineHeight: '125%', fontFamily: "Inter" }}>
                  Sign up for the Stokastic Sims package to get access to these game changing tools.
                </Typography>
              </Grid>
              <Grid item xs={12} lg={5} container direction='row' spacing={1} alignItems='center' justifyContent='space-between'>
                <Grid item xs={5} lg={3}>
                  <Box sx={{ padding: '8px' }}>
                    <Button
                      variant='contained'
                      href='https://stokastic.com/pricing'
                      sx={{
                        background: '#0042C1',
                        width: '100%',
                        color: 'white',
                        fontFamily: "Inter",
                        fontSize: {xs: '12px', lg: "14px"},
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Join Stokastic Sims
                    </Button>
                  </Box>
                </Grid>
                {
                  !auth && (
                    <Grid item xs={4} lg={3}>
                      <Stack padding='8px'>
                        <AuthButton button={true} />
                      </Stack>
                    </Grid>
                  )
                }
                <Grid item xs={3} lg={6}>
                  <Link href="https://stokastic.com" color='inherit'>
                    <Box display="flex" alignItems="center" justifyContent="center" margin='2px' fontSize={{xs: '12px', lg: "14px"}} whiteSpace='nowrap'>
                      <Box height={20} width={20} style={{ fontFamily: "Inter" }}>
                        <img
                          src={`${process.env.PUBLIC_URL}/images/Stokastic_Logo_-25.png`}
                          alt=""
                          style={{ height: '100%', width: '100%', }}
                        />
                      </Box>
                      Stokastic Home
                    </Box>
                  </Link>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </StyledSettingsContainer>
  )
}

const mapStateToProps = (state: any) => {
  const {
    selectedSport,
    selectedSite,
  } = state.common;
  return {
    selectedSport,
    selectedSite,
  };
};

const mapDispatchToProps = {
  SetSport: setSport,
  SetSite: setSite
};

export default connect(mapStateToProps, mapDispatchToProps)(NotAuthenticatedView);